export class VendorModel {
  id: number;
  name: string;
}
